import { Component, OnInit, ViewChild } from '@angular/core';
import { EventService, MapService } from '../../services';
import { ReportService } from '../../services';
import { TaskService } from '../../services';
import { UserService } from '../../services';
import { BaseReportComponent } from './base-report.component';
import moment from 'moment';
import { IFuelLevelMapper } from 'src/app/interfaces/fuel-level-mapper';
import { FuelLevelService } from 'src/app/services/fuel-level.service';

export enum JobStatus {
  Completed = 1,
  Invoiced = 2,
  Closed = 3,
  Cancelled = 4,
  Created = 5,
  Started = 6,
}

@Component({
  selector: 'jobs-report',
  templateUrl: './jobs-report.component.html',
})
export class JobsReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  moment = moment;

  public tags: any[] = [];
  public costCodes: any[] = [];
  public departments: any[] = [];
  public teams: any[] = [];
  public regions: any[] = [];
  public depots: any[] = [];
  public taskTypes: any[] = [];
  public suppliers: any[] = [];
  public jobStatuses: any[] = [];
  public statusClosed = JobStatus.Closed;
  public selectedJob: any;
  public columns: { label: string; value?: string; style?: string }[];
  public rows: any[] = [];
  public maxTasks: number = 0;
  private fuelLevelMappers: IFuelLevelMapper[] = [];

  constructor(
    reportService: ReportService<any, any>,
    eventService: EventService,
    private userService: UserService,
    public mapService: MapService,
    public taskService: TaskService,
    private fuelLevelService: FuelLevelService,
  ) {
    super(reportService, false, eventService);

    reportService.url = '/api/report/job';

    eventService.ReportChangedEvent.subscribe((input) => {
      this.parseReport(input);
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
    this.search();
    this.getFuelLevelMappers();
  }

  private getFuelLevelMappers() {
    this.fuelLevelService.getFuelLevels().then((fuelLevels) => {
      if (fuelLevels) {
        this.fuelLevelMappers = fuelLevels;
      }
    });
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.tags = [];
    this.costCodes = [];
    this.departments = [];
    this.teams = [];
    this.regions = [];
    this.depots = [];
    this.taskTypes = [];
    this.suppliers = [];

    if (this.filterParam) {
      console.log(this.filterParam);
      if (this.filterParam.tags) {
        this.tags.push({ label: 'Please Select', value: null });
        this.filterParam.tags
          .sort((x) => x.id)
          .forEach((x) => {
            this.tags.push({ label: x.description, value: x.id });
          });
      }

      if (this.filterParam.costcodes) {
        this.costCodes.push({ label: 'Please Select', value: null });
        this.filterParam.costcodes
          .sort((x) => x.id)
          .forEach((x) => {
            this.costCodes.push({ label: x.name, value: x.id });
          });
      }

      if (this.filterParam.departments) {
        this.departments.push({ label: 'Please Select', value: null });
        this.filterParam.departments
          .sort((x) => x.id)
          .forEach((x) => {
            this.departments.push({ label: x.name, value: x.id });
          });
      }

      if (this.filterParam.regions) {
        this.regions.push({ label: 'Please Select', value: null });
        this.filterParam.regions
          .sort((x) => x.id)
          .forEach((x) => {
            this.regions.push({ label: x.name, value: x.id });
          });
      }

      if (this.filterParam.depots) {
        this.depots.push({ label: 'Please Select', value: null });
        this.filterParam.depots
          .sort((x) => x.id)
          .forEach((x) => {
            this.depots.push({ label: x.name, value: x.id });
          });
      }

      if (this.filterParam.types) {
        this.taskTypes.push({ label: 'Please Select', value: null });
        this.filterParam.types
          .sort((x) => x.id)
          .forEach((x) => {
            this.taskTypes.push({ label: x.name, value: x.id });
          });
      }

      if (this.filterParam.suppliers) {
        this.suppliers.push({ label: 'Please Select', value: null });
        this.filterParam.suppliers.forEach((x) => {
          this.suppliers.push({ label: x.label, value: x.value });
        });
      }

      if (this.filterParam.statuses) {
        //this.jobStatuses.push({ label: 'Please Select', value: null });
        if (this.filterParam.statuses) {
          this.filterParam.statuses
            .sort((x) => x.id)
            .forEach((x) => {
              this.jobStatuses.push({ label: x.name, value: x.id });
            });
        }
      }
    }
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        createDateFrom: {},
        createDateTo: {},
        tag: {},
        costCode: {},
        department: {},
        team: {},
        region: {},
        depot: {},
        type: {},
        supplier: {},
        completedDateFrom: {},
        completedDateTo: {},
        status: {},
      },
    };
  }

  regionChange(event) {
    this.filterVal.filters.depots = {};
    this.loadDepots(event.value);
  }

  loadDepots(regionId) {
    this.depots = [];
    this.depots.push({ label: 'Please Select', value: null });
    if (regionId == null) {
      if (this.filterParam.depots) {
        this.filterParam.depots
          .sort((x) => x.id)
          .forEach((x) => {
            this.depots.push({ label: x.name, value: x.id });
          });
      }
    }
    if (regionId != null) {
      if (this.filterParam.depots) {
        this.filterParam.depots
          .filter((x) => x.regionId == regionId)
          .sort((x) => x.id)
          .forEach((x) => {
            this.depots.push({ label: x.name, value: x.id });
          });
      }
    }
  }

  foobar() {
    return function (results) {
      console.log('PAGE', results);
    };
  }

  private parseReport(input: any) {
    this.rows = [];

    this.columns = [
      { label: 'Job Ref', style: 'width: 100px' },
      { label: 'Created', style: 'width: 100px' },
      { label: 'Pickup', style: 'width: 100px' },
      { label: 'DropOff', style: 'width: 100px' },
      { label: 'Type', style: 'width: 100px' },
      { label: 'Movement Amount', style: 'width: 100px' },
      { label: 'Job/Final Price', style: 'width: 100px' },
      { label: 'Status', style: 'width: 100px' },
    ];

    if (this.organisationTypeId == 1) {
      this.columns.push({ label: 'Supplier', style: 'width: 100px' });
    }

    if (this.organisationTypeId == 2 || this.organisationTypeId == 4) {
      this.columns.push({ label: 'Dept', style: 'width: 100px' });
      this.columns.push({ label: 'Team', style: 'width: 100px' });
      this.columns.push({ label: 'Region', style: 'width: 100px' });
      this.columns.push({ label: 'Depot', style: 'width: 100px' });
    }

    this.columns.push({ label: 'Acct Code', style: 'width: 110px' });

    this.maxTasks = 0;

    input.items.forEach((x) => {
      if (x.tasks.length > this.maxTasks) {
        this.maxTasks = x.tasks.length;
      }
    });

    if (this.maxTasks > 0) {
      for (let cnt = 1; cnt <= this.maxTasks; cnt++) {
        this.columns.push({ label: 'Customer', style: 'width: 100px;' });
        this.columns.push({ label: 'Last Pickup From', style: 'width: 100px;' });
        this.columns.push({ label: 'Last Pickup To', style: 'width: 100px;' });
        this.columns.push({ label: 'Postcode From', style: 'width: 100px;' });
        this.columns.push({ label: 'Postcode To', style: 'width: 100px;' });
        this.columns.push({ label: 'Vehicle', style: 'width: 100px;' });
        this.columns.push({ label: 'Reg', style: 'width: 100px;' });
        this.columns.push({ label: 'Mileage', style: 'width: 100px;' });
        this.columns.push({ label: 'Time', style: 'width: 100px;' });
        this.columns.push({ label: 'Pickup Odo', style: 'width: 100px' });
        this.columns.push({ label: 'Dropoff Odo', style: 'width: 100px;' });
        this.columns.push({ label: 'Pickup Fuel', style: 'width: 100px;' });
        this.columns.push({ label: 'Dropoff Fuel', style: 'width: 100px;' });
        this.columns.push({ label: 'Supplier Movement Amt', style: 'width: 100px;' });
        this.columns.push({ label: 'Supplier Final Amt', style: 'width: 100px' });
      }
    }

    input.items.forEach((x) => {
      let row = [
        { value: x.orderRef },
        { value: x.dateCreated, cellType: 'date', dateFormat: 'dd/MM/YY' },
        { value: x.lastPickUp, cellType: 'date', dateFormat: 'dd/MM/YY' },
        { value: x.lastDropOff, cellType: 'date', dateFormat: 'dd/MM/YY' },
        { value: x.movementType },
        { value: x.supplierPrice, cellType: 'currency' },
        { value: x.transactionsSum, cellType: 'currency' },
        { value: x.status },
      ];

      if (this.organisationTypeId == 1) {
        row.push({ value: x.supplier });
      }

      if (this.organisationTypeId == 2 || this.organisationTypeId == 4) {
        row.push({ value: x.department });
        row.push({ value: x.team });
        row.push({ value: x.region });
        row.push({ value: x.depot });
      }

      row.push({ value: x.costCodes });

      x.tasks.forEach((i) => {
        row.push({ value: i.customerInfo.name });
        row.push({
          value: i.pickupEarliestDateTime,
          cellType: 'date',
          dateFormat: 'ddd DD MM HH:mm',
        });
        row.push({
          value: i.pickupLatestDateTime,
          cellType: 'date',
          dateFormat: 'ddd DD MM HH:mm',
        });
        row.push({ value: i.pickupLocation.postcode });
        row.push({ value: i.dropoffLocation.postcode });
        row.push({ value: i.vehicle.make + ' ' + i.vehicle.model });
        row.push({ value: i.registrationNumber });
        row.push({ value: this.mapService.getMiles(i.distance) });
        row.push({ value: i.estimateTime });
        row.push({ value: i.pickupOdometer });
        row.push({ value: i.dropoffOdometer });
        row.push({ value: i.vehicle.isElectric ? i.pickupFuel : this.getFuelString(i.pickupFuel) });
        row.push({
          value: i.vehicle.isElectric ? i.dropoffFuel : this.getFuelString(i.dropoffFuel),
        });
        row.push({ value: i.supplierMovementAmount, cellType: 'currency' });
        row.push({ value: i.supplierFinalAmount, cellType: 'currency' });
      });

      this.rows.push({ cells: row });
    });
  }

  private getFuelString(fuel: number): string {
    const fuelLevel = this.fuelLevelMappers.find((x) => x.fuelLevel == fuel);
    return fuelLevel?.fuelLevelName;
  }
}
